import React from 'react';
import PropTypes from 'prop-types';
import logger from '~/services/logger';
import StreamYardVsCompetitor from '../StreamYardVsCompetitor';

const templateRegistry = {
	'competitor-comparison': StreamYardVsCompetitor,
};

const JsonLandingPageTemplate = ({ data }) => {
	const TemplateComponent = templateRegistry[data.template];

	if (!TemplateComponent) {
		logger.error('Template not found', { template: data.template });
		return null;
	}

	return <TemplateComponent data={data} />;
};

JsonLandingPageTemplate.propTypes = {
	data: PropTypes.shape({
		template: PropTypes.string.isRequired,
		version: PropTypes.string.isRequired,
		metadata: PropTypes.shape({
			slug: PropTypes.string.isRequired,
			translationNamespace: PropTypes.string.isRequired,
		}).isRequired,
		content: PropTypes.object.isRequired,
	}).isRequired,
};

export default JsonLandingPageTemplate;
